import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  createPaymentIntent,
  doCheckOut,
  createWalletPaymentIntent,
  userMetaDetails,
} from "../checkout/actions";

import { GetUserById, isGuestOrPremiumUser } from "../settings/actions";
import CheckoutC from "./component";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createPaymentIntentConnect: createPaymentIntent,
      doCheckOutConnect: doCheckOut,
      GetUserByIdConnect: GetUserById,
      IsGuestOrPremiumUserConnect: isGuestOrPremiumUser,
      createWalletPaymentIntentConnect: createWalletPaymentIntent,
      userMetaConnect: userMetaDetails,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutC);
